import { css } from '@emotion/core'

export const contentSection = css`
  margin-left: 0;
  transition: margin-left 0.3s ease;
`
